import { useMemo } from "react";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles/lib/IStyleFunction";
import { useTheme } from "@fluentui/react";
import { IDetailsColumnStyleProps, IDetailsColumnStyles } from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";

const classNames = {
  host: `StringListRendererHost`,
  root: `StringListRenderer`,
  text: `StringListRendererText`,
  tooltip: `StringListRendererTooltip`
};

export function useOptionListRendererStyles(
  styles?: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles>
) {
  const { fonts } = useTheme();

  const styleSet = useMemo(
    () => mergeStyleSets(
      {
        host: [classNames.host, {}],
        root: [
          classNames.root,
          {
            width: `100%`,
            ...textOverflow
          }
        ],
        text: [
          classNames.text,
          {
            textTransform: `capitalize`
          }
        ],
        tooltip: [
          classNames.tooltip,
          {
            margin: 0,
            padding: 0,
            paddingLeft: `10px`,
            listStyle: `none`,
            "& > li": {
              listStyle: `none`
            }
          }
        ]
      },
      { host: styles }
    ),
    [styles]
  );

  const font = `${fonts.medium.fontSize} ${fonts.medium.fontFamily}`;

  return {
    styleSet,
    font
  };
}
